export const removeByIndex = <T>(array?: T[] | null, index?: number) => {
  if (!array || typeof index !== 'number') {
    return []
  }
  const newArray = [...array]
  newArray.splice(index, 1)
  return newArray
}
